import React from 'react'
import SelectBox from '../../commons/SelectBox'

class Target extends React.Component {
  render() {
    const {
      value,
      onChange,
    } = this.props

    return(
      <div className='card card-single'>
        <div className='card-body'>
          <p>
            { I18n.t(`onboarding.loan_target.purchase.question`) }
          </p>
          <div className='row no-gutters'>
            <div className='col-12'>
              <SelectBox
                checked={ value == 'own_home' }
                value='own_home'
                text={ I18n.t(`onboarding.loan_target.purchase.answer.own_home`) }
                onChange={ onChange }
              />
            </div>
            <div className='col-12'>
              <SelectBox
                checked={ value == 'investment' }
                value='investment'
                text={ I18n.t(`onboarding.loan_target.purchase.answer.investment`) }
                onChange={ onChange }
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Target;
